import React from 'react';

export default function AboutUsSectionDashboardPageHeadings9() {
    return (
        <React.Fragment>
            <section className="pt-20 bg-white" style={{ backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")', backgroundPosition: 'center' }}>
                <div className="container px-4 mx-auto">
                    <div className="max-w-4xl mx-auto text-center">
                        <span className="inline-block py-px px-2 mb-4 text-xl leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl">About Us</span>
                        <h3 className="mb-4 text-4xl md:text-5xl leading-tight text-darkCoolGray-900 font-bold tracking-tighter">Who We Are</h3>
                        <p className="text-lg md:text-xl text-coolGray-500 font-medium">
                            Learn more about Bagga International, our mission, and our commitment to quality in tool bags, pouches, and belts. We strive to deliver excellence and innovation in every product, ensuring satisfaction for our customers worldwide.
                        </p>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

